<template>
  <div id="app" v-if="show">
    <menu-a></menu-a>
    <router-view />
  </div>
</template>

<script>
import menu from './components/menu/menu'
import { UrlSearch } from './components/utils/UrlSearch'
import { setToken, removeToken, getToken } from './components/utils/auth'
import {
  setItem,
  getItem,
  removeItem
} from './components/utils/sessionStorage'
import { setItem1 } from './components/utils/locstorage'
import { setuser, install } from './components/views/api/user'
import { login } from './components/views/api/apis/user'
import { removeKey } from './components/utils/sessionStorage'
import { getChartFree } from './components/views/api/home'
import store from '@/store'
var userparam = UrlSearch()
const Base64 = require('js-base64').Base64
export default {
  name: 'App',
  components: {
    'menu-a': menu
  },
  data () {
    return {
      show: false,
      customer_id: ''
    }
  },
  mounted () {
    if (userparam.play > 0) {
      console.log(userparam)
      setItem1('play', JSON.stringify(userparam))
      if (window.top == window.self) {
        // var path =
        //     'https://' +
        //     JSON.parse(getToken('userparam')).shop +
        //     '/admin/apps/' +
        //     getToken('apps') +
        //     '/Finance'
        var path =
            'https://' +
            store.getters.shopTokenuserparam.shop +
            '/admin/apps/' +
            store.getters.shopTokenapps +
            '/Finance'
        window.location.assign(path)
      }
    } else {
      // setToken('userparam', userparam) 这里
      store.dispatch('setUserparam', userparam)
      console.log(userparam)
      if (userparam.shop == undefined) {
        // removeToken()
        store.dispatch('setUser', null)
        this.$router.push({ path: '/404' })
      } else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 1)'
        })
        const param = {}
        Object.keys(userparam).forEach(key => {
          if (!['install', 'play'].includes(key)) {
            param[key] = userparam[key]
          }
        })
        const baseData = Base64.encode(JSON.stringify(param))
        setItem(baseData)
        if (userparam.install > 0) {
          install({ params: baseData })
            .then(response => {
              console.log(response)
              if (response.data.ask == 1) {
                console.log('但是')
                this.getShopifyToken()
                const timer = function () {
                  setInterval(() => {
                    this.getShopifyToken()
                  }, 30000)
                }
                timer()

                loading.close()
                // removeToken()
                store.dispatch('setUser', null)
                if (window.top == window.self) {
                  var path =
                      'https://' +
                      UrlSearch().shop +
                      '/admin/apps/' +
                      response.data.apps
                  window.location.assign(path)
                } else {
                  this.$router.push({ path: '/login' })
                }
              } else if (response.data.needInstall) {
                let url =
                    'https://' +
                    userparam.shop +
                    '/admin/oauth/authorize?client_id=' +
                    response.data.needInstall.client_id +
                    '&redirect_uri=https://appshopify.sendfromchina.com/install&scope=' +
                    response.data.needInstall.scope
                window.top.location.href = url
              } else {
                console.log(response.data.msg)
              }
            })
            .catch(error => {
              console.log(error)
            })
          // window.top == window.self为true表示单独打开页面 跳转到shopifyapp应用(本地调试需要改window.top == window.self为false)
          // window.top == window.self
        } else {
          // setItem(JSON.stringify(param))
          // console.log('东风股份是加速度覅就', getItem())
          setTimeout(() => {
            if (store.getters.token) {
              this.userFun(loading, baseData)
            } else {
              setTimeout(() => {
                this.userFun(loading, baseData)
              }, 500)
            }
          }, 500)
        }
      }
    }
  },
  methods: {
    getShopifyToken () {
      console.log('第一')
      var AppBridge = window['app-bridge']
      var createApp = AppBridge.default
      var getSessionToken = window['app-bridge-utils'].getSessionToken
      var app = createApp({
        // apiKey: '4e8b394d07420fee4cb26baeeafe1ca9', // 测试
        apiKey: '9bd8c37989642e52c90714a8d713b903', // 正式
        host: store.getters.urlSearch ? store.getters.urlSearch.host : UrlSearch().host
      })

      getSessionToken(app).then(session_token => getPageContent(session_token)).catch(err => {
        alert('App authentication failed, try refreshing the page')
        console.log(err)
      })

      function getPageContent (session_token) {
        store.dispatch('setToken', session_token)
        console.log('token:', store.getters.token)
        // if (window.thisComponent) {
        //   window.thisComponent.sMacAddr = 'Bearer ' + session_token
        // }
        //   fetch('{{ url_behind_session_token_auth }}', {
        //       headers: new Headers({
        //           'Authorization': 'Bearer ' + session_token
        //       })
        //   }).then(data => data.json()).then(json => {
        //       //do stuff
        //       console.error(json);
        //   });
      }
    },

    getBalance () {
      // 刷新余额信息
      getChartFree({ customer_id: this.customer_id }).then(response => {
        removeKey('balance')
        if (response.data.ask === 1 && response.data.data) {
          store.dispatch('updateBalance', response.data.data.balance)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    userFun (loading, baseData) {
      const _this = this
      setuser({ params: baseData })
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            if (window.top == window.self) {
              var path =
                        'https://' +
                        userparam.shop +
                        '/admin/apps/' +
                        response.data.apps
              window.location.assign(path)
            } else {
              this.show = true
              loading.close()

              _this.getShopifyToken()
              const timer = function () {
                setInterval(() => {
                  _this.getShopifyToken()
                }, 30000)
              }
              timer()
              var username = response.data.userData
              // setToken('apps', response.data.apps) 这里
              // setToken('user', username)
              console.log('走这里啊')
              store.dispatch('setApps', response.data.apps)
              store.dispatch('setUser', username)
              this.customer_id = username.customer_id
              if (store.getters.token) {
                this.getBalance()
              }
              store.dispatch('updateusername', username.customer_id)
              // 如果token已存，则切换路由
              // setTimeout(() => {
              //   if (store.getters.token) {
              //     alert(store.getters.token)
              //     store.dispatch('updatemenu', '/home')
              //   }
              // }, 1000)
              const interval = setInterval(() => {
                if (store.getters.token) {
                  clearInterval(interval)
                  this.getBalance()
                  store.dispatch('updatemenu', '/home')
                }
              }, 500)
              // setTimeout(() => {
              //   store.dispatch('updatemenu', '/home')
              // }, 500)
            }

            // this.$router.push({ path: "/home" });
          } else {
            if (response.data.needInstall) {
              this.show = true
              // setToken('apps', response.data.apps) 这里
              store.dispatch('setApps', response.data.apps)
              // let url = 'https://allenshows2.myshopify.com/admin/oauth/authorize?client_id=4e8b394d07420fee4cb26baeeafe1ca9&scope=read_products,write_products,read_product_listings,read_locations,read_inventory,write_inventory,read_orders,write_orders,read_fulfillments,write_fulfillments,read_shipping,write_shipping&redirect_uri=https://appshopify.sendfromchina.com/install'
              // let url =
              //           'https://' +
              //           userparam.shop +
              //           '/admin/oauth/authorize?client_id=' +
              //           response.data.needInstall.client_id +
              //           '&scope=' + response.data.needInstall.scope +
              //           '&redirect_uri=https://appshopify.sendfromchina.com/install'
              let url = `https://${userparam.shop}/admin/oauth/authorize?client_id=${response.data.needInstall.client_id}&scope=${response.data.needInstall.scope}&redirect_uri=https://appshopify.sendfromchina.com/install`
              // console.log(url)
              // alert(JSON.stringify(response.data.needInstall))
              // alert(url)
              // window.top.location.href = url
              window.location.assign(url)
              // alert('1223', url)
            } else if (response.data.needlogin === 1) {
              // alert('的')
              _this.getShopifyToken()
              const timer = function () {
                setInterval(() => {
                  _this.getShopifyToken()
                }, 30000)
              }
              timer()
              loading.close()
              this.show = true
              store.dispatch('setUser', null)
              if (window.top == window.self) {
                this.show = false
                var path =
                          'https://' +
                          UrlSearch().shop +
                          '/admin/apps/' +
                          response.data.apps
                window.location.assign(path)
              } else {
                this.show = true
                this.$router.push({ path: '/login' })
              }
            } else {
              loading.close()
              this.show = true
              // removeToken()
              store.dispatch('setUser', null)
              if (window.top == window.self) {
                this.show = false
                var path =
                          'https://' +
                          UrlSearch().shop +
                          '/admin/apps/' +
                          response.data.apps
                window.location.assign(path)
              } else {
                this.show = true
                this.$router.push({ path: '/login' })
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  a {
    text-decoration: none;
  }

  img {
    border: none;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active,
  .el-badge__content {
    background-color: #8989ba;
  }
  .zZindex {
    z-index:3000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue